import QS from 'qs';
import { fetch } from '../utils/fetch';

export function getNewsList() {
  return fetch({
    url: '/api/all-news',
    method: 'get',
  });
}

export function saveNews(news) {
  return fetch({
    url: '/api/news',
    method: 'post',
    data: QS.stringify(news),
  });
}


export function deleteNews(id) {
  return fetch({
    url: `/api/news/${id}`,
    method: 'delete',
  });
}

export function getNews(id) {
  return fetch({
    url: `/api/news/${id}`,
    method: 'get',
  });
}

export function updateNews(news) {
  return fetch({
    url: '/api/news',
    method: 'patch',
    data: QS.stringify(news),
  });
}
